module.exports = __webpack_public_path__ + "img/vc.13a0726e.svg";